module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content close-date-picker city_collection_reports_pop report_generation_progress_main",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "common_save_btn",
    class: [_vm.addButtonClass, {
      'general_reports_btn1': (_vm.tableCount <= 10)
    }]
  }, [_c('button', {
    staticClass: "btn gradientbt",
    on: {
      "click": _vm.refreshReportList
    }
  }, [_vm._v("\n                Refresh\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn gradientbt ml-5",
    on: {
      "click": _vm.gotoReportGeneration
    }
  }, [_vm._v("\n                Generate Reports\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-server-table', {
    ref: "tripReportTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('div', {
          staticClass: "c-pointer report_generation_progress"
        }, [(props.row.fileUrl == '') ? _c('a', {
          attrs: {
            "disabled": ""
          }
        }, [_vm._v("Report Generation In Progress.")]) : _vm._e(), _vm._v(" "), (props.row.fileUrl != '') ? _c('a', {
          staticClass: "fa fa-download",
          attrs: {
            "role": "button",
            "href": props.row.fileUrl,
            "target": "_blank"
          }
        }) : _vm._e()])])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1), _vm._v(" "), (_vm.isGenerateReport) ? _c('div', {}, [(_vm.isGenerateReport) ? _c('div', {}, [_c('div', {}, [_c('div', {}, [_c('div', {
    staticClass: "overlay waste_type_pop",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('vue-form', {
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Generate Reports")]), _vm._v(" "), (_vm.reportLoading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader'), _vm._v(" "), _c('p', [_vm._v("Please wait, report generation is in progress.")])], 1) : _vm._e(), _vm._v(" "), (!_vm.reportLoading) ? _c('div', {
    staticClass: "col-sm-12 scroll_pop",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [(_vm.adminCheck == 'superAdmin') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.city),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Select City")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "track-by": "value",
      "disabled": _vm.isCityDisable,
      "label": "name",
      "placeholder": "Select City",
      "options": _vm.cityList,
      "name": "city",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "required": ""
    },
    on: {
      "select": _vm.onCheckedCity,
      "remove": _vm.onRemoveCity
    },
    model: {
      value: (_vm.tripReport.city),
      callback: function($$v) {
        _vm.$set(_vm.tripReport, "city", $$v)
      },
      expression: "tripReport.city"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "city",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.vehicles),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle Number")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "track-by": "id",
      "label": "name",
      "placeholder": "Select Vehicle",
      "options": _vm.vehicleList,
      "multiple": "",
      "name": "vehicle",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": ""
    },
    on: {
      "input": _vm.vehicleNumberBtn,
      "select": _vm.getVehicle,
      "remove": _vm.onRemoveVehicle
    },
    model: {
      value: (_vm.tripReport.vehicles),
      callback: function($$v) {
        _vm.$set(_vm.tripReport, "vehicles", $$v)
      },
      expression: "tripReport.vehicles"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vehicle",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', [_c('h5', {
    staticClass: "boxs1"
  }, [_vm._v("Trip Schedule Date Range")])]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.startDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Start Range")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "startDate",
      "required": "",
      "lang": "en",
      "name": "startDate",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY",
      "not-after": _vm.disabledAfter
    },
    on: {
      "change": _vm.datevalidation
    },
    model: {
      value: (_vm.tripReport.startDate),
      callback: function($$v) {
        _vm.$set(_vm.tripReport, "startDate", $$v)
      },
      expression: "tripReport.startDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "startDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.endDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("End Range")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "endDate",
      "required": "",
      "lang": "en",
      "name": "endDate",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY",
      "not-before": _vm.notBeforeEndDate,
      "not-after": _vm.enddateDisabledAfter
    },
    on: {
      "change": _vm.datevalidation1
    },
    model: {
      value: (_vm.tripReport.endDate),
      callback: function($$v) {
        _vm.$set(_vm.tripReport, "endDate", $$v)
      },
      expression: "tripReport.endDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "endDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onModalClose
    }
  }, [_vm._v("\n                                        Cancel\n                                    ")]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid && _vm.vehicleNumberBtnFlag)
    },
    on: {
      "click": _vm.generateReport
    }
  }, [_vm._v("\n                                        Generate\n                                    ")])])], 1)])])])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f982113"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/wasteReports/vehicle_trip_reports.vue
// module id = 2303
// module chunks = 1